import { StoredMediaCategory } from '../types/Media'

export const getRecParents = (
    categoryId: number,
    tree: StoredMediaCategory[]
) => {
    let parentIds: number[] = [categoryId]
    const node = tree.find((leaf) => leaf.id === categoryId)
    if (node && typeof node.parent_id === 'number' && node.parent_id !== 0) {
        parentIds = [
            ...parentIds,
            node.parent_id,
            ...getRecParents(node.parent_id, tree),
        ]
    }
    return parentIds
}
